import React, { useState } from 'react'
import { Panel } from 'rsuite'
import { isEmpty } from 'lodash'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { useForm, Controller } from 'react-hook-form'
import {
  uploadDocumentsSubProject,
  deleteDocumentSubProject,
  renameDocumentSubProject,
  downloadDocumentSubProject,
  getApprovalAttachmentsSubProject,
} from '../../redux/actions/reviewSummary'
import { startLoading, doneLoading } from '../../utils/loading'
import AttachFilesForm from '../attachfiles/AttachFilesForm'
import AttachFilesView from '../attachfiles/AttachFilesView'
import { downloadFile, previewFile } from '../../utils/fileUtil'
import notification from '../../utils/notification'

export default function ReviewSumarySubprojectUploadFileWidget({
  schema: _schema,
  showCommandButton,
}) {
  const { register, handleSubmit, errors, control, setValue, clearErrors, getValues } = useForm()
  const [formSchema, setFormSchema] = useState(_schema)
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState(false)
  const [deleteError, setDeleteError] = useState()
  const [renameError, setRenameError] = useState()

  const handleCallUploadFiles = async (request) => {
    startLoading()
    setIsLoading(true)
    setError()
    try {
      const response = await uploadDocumentsSubProject(projectId, request)
      setFormSchema((state) => {
        const allFiles = response.fileList?.value || []

        return {
          ...state,
          fileList: {
            ...state.fileList,
            value: allFiles,
          },
        }
      })
      setError(false)
    } catch (e) {
      setError('อัปโหลดไฟล์ไม่สำเร็จ')
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleCallDeleteFiles = async (request) => {
    startLoading()
    setIsLoading(true)
    setDeleteError(false)
    try {
      const response = await deleteDocumentSubProject(projectId, request)

      if (response) {
        const res = await getApprovalAttachmentsSubProject(projectId)

        setFormSchema((state) => {
          const allFiles = res?.fileList?.value || []

          return {
            ...state,
            fileList: {
              ...state.fileList,
              value: allFiles,
            },
          }
        })
      }
    } catch (e) {
      setDeleteError('ลบไฟล์ไม่สำเร็จ')
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleCallRenameFile = async (request) => {
    startLoading()
    setIsLoading(true)
    setRenameError()
    try {
      const response = await renameDocumentSubProject(projectId, request)
      setFormSchema((state) => {
        // const updatedFile = state.fileList.value.map((item, index) => {
        //   // console.log('item ', item)
        //   if (item.id === request.id) {
        //     return response
        //   }
        //   return item
        // })

        return {
          ...state,
          fileList: {
            ...state.fileList,
            value: response.fileList.value,
          },
        }
      })
      setRenameError(false)
    } catch (e) {
      console.log('error', e)
      // setRenameError('แก้ไขชื่อไฟล์ไม่สำเร็จ')
      notification.open('error', {
        title: 'แก้ไขชื่อไฟล์ไม่สำเร็จ',
      })
    }
    setIsLoading(false)
    doneLoading()
  }

  const onPreview = async (fileObj) => {
    startLoading()
    console.log('fileObj ', fileObj)
    try {
      const file = await downloadDocumentSubProject(projectId, fileObj.path)
      console.log('file ', file)
      previewFile(file, fileObj.name)
    } catch (err) {
      notification.open('error', {
        title: 'ดาวน์โหลดเอกสารไม่สำเร็จ',
      })
    }
    doneLoading()
  }

  const onDownload = async (fileObj) => {
    startLoading()
    try {
      const file = await downloadDocumentSubProject(projectId, fileObj.path)
      downloadFile(file, fileObj.name)
    } catch (err) {
      notification.open('error', {
        title: 'ดาวน์โหลดเอกสารไม่สำเร็จ',
      })
    }
    doneLoading()
  }

  const handleOnClickUpload = (filesData) => {
    if (isEmpty(filesData?.attachFiles)) {
      return
    }
    const formData = new FormData()
    filesData?.attachFiles.forEach((element) => {
      formData.append('files', element.blobFile)
    })
    handleCallUploadFiles(formData)
  }

  const handleOnClickDelete = (fileIndex) => {
    if (!formSchema?.fileList?.value?.[fileIndex]?.id) {
      return
    }
    const request = {
      id: formSchema.fileList.value[fileIndex].id,
      fileName: formSchema.fileList.value[fileIndex].name,
    }
    handleCallDeleteFiles(request)
  }

  const handleOnClickRenameFile = (file, newName) => {
    if (!newName) {
      return
    }
    const request = {
      id: file.id,
      name: newName,
      label: newName,
    }

    handleCallRenameFile(request)
  }

  return (
    <>
      {/* <Panel
        header={formSchema?.header}
        collapsible
        defaultExpanded
        bordered
        shaded
        style={{ marginBottom: 20 }}
      > */}
      <p>{`แนบไฟล์${formSchema.header ? formSchema.header : ''}`}</p>
      {!showCommandButton ? (
        <AttachFilesForm
          schema={formSchema?.fileList}
          register={register}
          Controller={Controller}
          control={control}
          errors={errors}
          setValue={setValue}
          clearErrors={clearErrors}
          onSubmit={handleSubmit(handleOnClickUpload)}
          onDelete={handleOnClickDelete}
          onUpdate={handleOnClickRenameFile}
          onDownload={onDownload}
          onPreview={onPreview}
          isChangSeqNo={false}
          isEditErr={renameError}
          isUploadErr={error}
          isDeleteError={deleteError}
          loading={isLoading}
        />
      ) : (
        <AttachFilesView
          schema={formSchema?.fileList}
          onDownload={onDownload}
          onPreview={onPreview}
        />
      )}
      {/* </Panel> */}
    </>
  )
}
